var React = require('react');

function Plus16x16 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Color=Black, State=Default, Size=16x16"},React.createElement("path",{"id":"Vector","d":"M8 1v7m0 0v7m0-7h7M8 8H1","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round"})));
}

Plus16x16.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Plus16x16;

Plus16x16.default = Plus16x16;
